import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import { AudioChannel, AudioSettingsScope } from "../types";

export const AUDIO_CHANNEL_CONFIG: Record<
  AudioChannel,
  {
    label: string;
    defaultScope: AudioSettingsScope;
    Icon: typeof CallOutlinedIcon;
  }
> = {
  call: {
    label: "Call ringtone",
    defaultScope: "company",
    Icon: CallOutlinedIcon,
  },
  message: {
    label: "Message tone",
    defaultScope: "account",
    Icon: ChatBubbleOutlineRoundedIcon,
  },
  notification: {
    label: "Notification sound",
    defaultScope: "account",
    Icon: NotificationsNoneRoundedIcon,
  },
};
